import { BiBorderRadius } from "react-icons/bi";
import { LuSearch,LuSearchCheck } from "@/Components/Icons/Icons.jsx";
export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "exportProductMainDescription",
            actionText: "Description",
            label: "Init",
            outerIconName: LuSearch,
            component: "textarea",
            placeholder:
              "MACHINED PARTS & SPARES - BEARING BCK*RAW*Z1*Z3 DW.NO.262--07-0100/000",
            width: "100%",
            height: 95,
            sx: {
              borderRadius: 10,
            }, 
            required: true, 
          },
          {
            name: "exportProductMainDescriptionId",
            actionText: "Description",
            label: "Init",
            outerIconName: LuSearch,
            component: "textarea",
            placeholder:
              "MACHINED PARTS & SPARES - BEARING BCK*RAW*Z1*Z3 DW.NO.262--07-0100/000",
            width: "100%",
            height: 110,
            sx: {
              borderRadius: 10,
            },
            type: "autocomplete",
            endpoint: "getDescription",
            required: true, 
          },
          {
            component: "icon-toggle",
            name: "isDescription",
            checkedIcon: LuSearchCheck,
            uncheckedIcon: LuSearch,
            color: "primary",
            defaultValue: false,
            visibleOn : true
            // size : "medium",
          },
        ],
        row2: [
          {
            name: "exportProductMainRITCorHSNCodeId",
            label: "RITC",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            width: "50%",
            placeholder: "73261990",
            type: "autocomplete",
            endpoint: "getHsnCodeMaster",
            filterEndPoint: "getFilterHsnCode",
          },
          {
            name: "exportProductMainQuantity",
            label: "Quantity",
            component: "text-field",
            width: "30%",
            required: true,
            placeholder: "0.0000",
            dataType: "int",
          },
          {
            name: "exportProductMainQuantityUnitId",
            label: "Unit",
            component: "text-field",
            width: "20%",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getQuantity",
            placeholder: "KGS",
            required: true,
          },
        ],
        row3: [
          {
            name: "exportProductMainSQCQuantity",
            label: "SQC Qty",
            required: true,
            component: "text-field",
            width: "28%",
            placeholder: "0.0000",
            dataType: "int",
          },
          {
            name: "exportProductMainSQCQuantityUnitId",
            label: "Unit",
            component: "text-field",
            width: "20%",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getQuantity",
            iconColor: "gray-400",
            required: true,
          },
          {
            name: "exportProductMainUnitPrice",
            label: "Unit Price",
            component: "text-field",
            width: "30%",
            placeholder: "0.0000",
            dataType: "int",
          },
          {
            name: "exportInvoiceCurrency",
            component: "text-field",
            width: "20%",
            placeholder: "USD",
            isGet: false,
            disabled: true,
          },
        ],

        row4: [
          {
            name: "exportProductMainPer",
            label: "Per",
            component: "text-field",
            width: "28%",
            placeholder: "1",
            dataType: "int",
          },
          {
            name: "exportProductMainPerUnitId",
            label: "Unit",
            component: "text-field",
            width: "20%",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            placeholder: "KGS",
            endpoint: "getQuantity",
          },
          {
            name: "exportProductMainAmount",
            label: "Amount",
            component: "text-field",
            width: "30%",
            dataType: "int",
          },
          {
            name: "exportInvoiceCurrency",
            component: "text-field",
            width: "20%",
            placeholder: "USD",
            isGet: false,
            disabled: true,
          },
        ],
      },
    },
  ],
};
